const url2 = "https://exuberant-joelle-digitalcode-937bee37.koyeb.app";
const url = "https://api.doctoraecos.com";
const url3 = "http://localhost:8082";

export const ENV = {
  URL: url, // ← Modo desarrollo local
  URL_CLIENT: "https://api.doctoraecos.com",
};
